export const MODAL_HEADER = "project.creation.modal.header";
export const MODAL_SUBHEADER = "project.creation.modal.subheader";
export const MODAL_ALERTS_HEADER = "project.creation.modal.alert.header";
export const MODAL_ALERTS_SUBHEADER = "project.creation.modal.alert.subheader";
export const BUTTON_CLOSE = "common.close";
export const BUTTON_CREATE_PROJECT = "project.creation.modal.button.create";
export const BUTTON_CREATION_NEED_MORE_DOMAINS_TOOLTIP = "project.creation.modal.button.need.more.domains.tooltip";
